import {
  CREATED_NEW_MATERIAL_OWNER,
  DOES_OWNER_EXIST,
  MATERIAL_OWNER_UPDATED,
  SET_SELECTED_MATERIAL_OWNER,
  UPDATE_ALL_MATERIAL_OWNERS
} from "../actions";

const materialOwnersReducer = (
  state = {
    allMaterialOwners: [],
    newMaterialOwnerCreated: false,
    newOwner: null,
    ownerExists: { status: false },
    existingMaterialOwner: null,
    selectedMaterialOwner: null,
    materialOwnerUpdated: false
  },
  action
) => {
  switch (action.type) {
    case UPDATE_ALL_MATERIAL_OWNERS:
      return {
        ...state,
        allMaterialOwners: [...action.materialOwners],
        newMaterialOwnerCreated: false,
        materialOwnerUpdated: false,
        // newOwner: null
      };

    case CREATED_NEW_MATERIAL_OWNER:
      return {
        ...state,
        newMaterialOwnerCreated: true,
        newOwner: action.newOwner
      };

    case DOES_OWNER_EXIST:
      return {
        ...state,
        ownerExists: { status: action.status },
        existingMaterialOwner: action.materialOwner,
      };
    case SET_SELECTED_MATERIAL_OWNER:
      return {
        ...state,
        selectedMaterialOwner: { ...action.materialOwner },
      };

      case MATERIAL_OWNER_UPDATED:
        return {
          ...state,
          materialOwnerUpdated: true,
        };

    default:
      return state;
  }
};

export default materialOwnersReducer;
